import { Component, Inject, Input, OnInit } from "@angular/core";
import { UntypedFormBuilder, Validators } from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { DialogService } from "primeng/dynamicdialog";
import { EmpresasService } from "@p-parametria/mantenimiento/abc-empresas/services/empresas.service";
import { SwalService } from "@shared/utils/swal.service";
import { ISetEmpresaReq } from "@p-parametria/mantenimiento/abc-empresas/interfaces/IABCEmpresas";
import { AbcEmpresasCustomizablesComponent } from "../abc-empresas-customizables/abc-empresas-customizables.component";
import { AbcEmpresasCuentasComponent } from "../abc-empresas-cuentas/abc-empresas-cuentas.component";
import { AbcEmpresasSucursalesComponent } from "../abc-empresas-sucursales/abc-empresas-sucursales.component";

@Component({
  selector: "app-abc-empresas-form",
  templateUrl: "./abc-empresas-form.component.html",
  styleUrls: ["./abc-empresas-form.component.css"],
  providers: [DialogService],
})
export class AbcEmpresasFormComponent implements OnInit {
  @Input() modelRecived: any;
  public loading: boolean;
  public breakpoint: number;
  listcve_Estado: any[] = [];
  listcve_Tipo: any[] = [];
  constructor(
    private _fb: UntypedFormBuilder,
    private _dialogRef: MatDialogRef<AbcEmpresasFormComponent>,
    private empresasService: EmpresasService,
    private _swalService: SwalService,
    public _dialog: MatDialog,
    private dialogService: DialogService,
    @Inject(MAT_DIALOG_DATA) public model: any
  ) {}

  ngOnInit(): void {
    this.setForm();
    this.getEstados();
    this.getTipos();
  }

  getEstados() {
    this.empresasService.GetEstados().subscribe((res) => {
      this.listcve_Estado = res.data;
    });
  }

  getTipos() {
    this.empresasService.GetTipos().subscribe((res) => {
      this.listcve_Tipo = res.data;
    });
  }

  form = this._fb.group({
    sEmpresa: ["", Validators.required],
    ciudad: [""],
    sNombre: ["", Validators.required],
    cuentaContable: [""],
    cve_Estado: [""],
    sTipo: [""],
    colonia: [""],
    responsable: [""],
    calle: [""],
    telefono: [""],
    cp: [0],
    del_Mun: ["", Validators.email], // Usado para email, porque ??
  });
  formValue(value: string) {
    return this.form.get(value);
  }
  setForm(): void {
    this.modelRecived = this.model;
    if (this.modelRecived) {
      let model: any = this.modelRecived;
      const setModel = {
        sEmpresa: model.sEmpresa,
        sNombre: model.sNombre,
        cuentaContable: model.cuentaContable,
        responsable: model.responsable,
        calle: model.calle,
        colonia: model.colonia,
        ciudad: model.ciudad,
        del_Mun: model.del_Mun,
        cve_Estado: model.cve_Estado,
        cp: model.cp,
        telefono: model.telefono,
        sTipo: model.sTipo,
      };
      this.form.controls["sEmpresa"].disable();
      this.form.patchValue(setModel);
    }
  }
  create(model: any) {
    if (this.form.valid) {
      this.loading = true;
      const payload: ISetEmpresaReq = {
        tope: "",
        cmd: "",
        sEmpresa: model.sEmpresa,
        sNombre: model.sNombre,
        cuentacontable: model.cuentaContable,
        responsable: model.responsable,
        calle: model.calle,
        colonia: model.colonia,
        ciudad: model.ciudad,
        del_mun: model.del_Mun,
        cve_estado: model.cve_Estado,
        cp: model.cp,
        telefono: model.telefono.toString(),
        stipo: model.sTipo,
      };
      this.empresasService.SetEmpresa(payload).subscribe((res) => {
        this.loading = false;
        if (res) {
          this._dialogRef.close(true);
          this._swalService.success("Agregado");
        } else
          this._swalService.error(
            "No Agregado, Puede ser que el codigo ya exista, valide con una diferente por favor!"
          );
      });
    }
  }

  update(model: any) {
    if (this.form.valid) {
      this.loading = true;
      const payload: ISetEmpresaReq = {
        tope: "",
        cmd: "",
        sEmpresa: this.modelRecived.sEmpresa,
        sNombre: model.sNombre,
        cuentacontable: model.cuentaContable,
        responsable: model.responsable,
        calle: model.calle,
        colonia: model.colonia,
        ciudad: model.ciudad,
        del_mun: model.del_Mun,
        cve_estado: model.cve_Estado,
        cp: model.cp,
        telefono: model.telefono.toString(),
        stipo: model.sTipo,
      };
      this.empresasService.UpdateEmpresa(payload).subscribe((res) => {
        this.loading = false;
        if (res) {
          this._dialogRef.close(true);
          this._swalService.success("Editado");
        } else this._swalService.error("No Editado");
      });
    }
  }

  customizables() {
    const dialogRef = this._dialog.open(AbcEmpresasCustomizablesComponent, {
      width: "1000px",
      height: "1000px",
      data: this.modelRecived,
    });
    dialogRef.afterClosed().subscribe((res) => {});
  }

  cuentas() {
    const dialogRef = this._dialog.open(AbcEmpresasCuentasComponent, {
      width: "1000px",
      height: "600px",
      data: this.modelRecived,
    });
    dialogRef.afterClosed().subscribe((res) => {});
  }

  openSucursales(): void {
    const ref = this.dialogService.open(AbcEmpresasSucursalesComponent, {
      header: "Sucursales",
      width: "80%",
      height: "100%",
      data: {
        empresa: this.modelRecived,
        claveEmpresa: this.modelRecived.sEmpresa,
      },
    });
  }

  close() {
    this._dialogRef.close();
  }
}
